<cng-table [tableDef]="tableDef" [pagination]="true">
  <!-- Caption -->
  <ng-container *cngCaptionDef>{{ 'history:viewContacts.contactList' | translate }}</ng-container>

  <!-- Filter -->
  <ng-container *cngTableFilterDef>
    <cng-select-filter
      [filterName]="Filter.REPOSITORY"
      label="history:viewContacts.contactBase"
      [options]="repositories$ | async"
      [multi]="true"
    >
    </cng-select-filter>
  </ng-container>
  <ng-container *cngTableFilterDef>
    <cng-input-filter [filterName]="Filter.FIRSTNAME" label="commons:basic.firstname"></cng-input-filter>
    <cng-input-filter [filterName]="Filter.LASTNAME" label="commons:basic.lastname"></cng-input-filter>
  </ng-container>
  <ng-container *cngTableFilterDef>
    <cng-input-filter [filterName]="Filter.CONTACT_ID" label="commons:basic.contactId"></cng-input-filter>
    <cng-input-filter [filterName]="Filter.COMPANY_NAME" label="commons:basic.companyName"></cng-input-filter>
  </ng-container>
  <ng-container *cngTableFilterDef>
    <cng-input-filter [filterName]="Filter.PHONE" label="commons:basic.phoneNumber"></cng-input-filter>
    <cng-input-filter [filterName]="Filter.MAIL" label="commons:basic.mail"></cng-input-filter>
  </ng-container>

  <!-- Global actions -->
  <cng-table-action-all [action]="TableAction.ADD" label="commons:actions.add" icon="cng-ico_add" minRowSelected="0">
  </cng-table-action-all>
  <cng-table-action-all [action]="TableAction.IMPORT" label="commons:actions.import" icon="cng-ico_import" minRowSelected="0">
  </cng-table-action-all>
  <cng-table-action-all [action]="TableAction.MERGE" label="commons:actions.merge" minRowSelected="2"> </cng-table-action-all>

  <!-- Row actions -->
  <cng-table-action-row
    *cngHasPermission="['HISTORIZATION::historization_contact:update']"
    [action]="TableAction.EDIT"
    label="commons:actions.edit"
    icon="cng-ico_edit"
  >
  </cng-table-action-row>
  <cng-table-action-row
    *cngHasPermission="['HISTORIZATION::historization_contact:consult']"
    [action]="TableAction.CONSULT"
    label="commons:actions.consult"
    icon="cng-ico_search"
  >
  </cng-table-action-row>
  <cng-table-action-row
    *cngHasPermission="['HISTORIZATION::historization_contact:delete']"
    [action]="TableAction.DELETE"
    label="commons:actions.delete"
    icon="cng-ico_supprimer"
  >
  </cng-table-action-row>
</cng-table>
